module.exports = __webpack_public_path__ + "img/slidebar-bg.cdf452fd.png";